import { useCampaigns } from "api/campaigns";
import { Subheader } from "components/Header/Subheader/Subheader";
import { SubheaderActionButton } from "components/Header/Subheader/SubheaderActionButton";
import { TopHeader } from "components/Header/TopHeader/TopHeader";
import { OLTabs } from "components/Tabs/OLTabs";
import { useMessage } from "hooks/intl";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { links } from "utilities/links";
import LeaderboardDetails from "./LeaderboardDetails";
import TopRanking from "./TopRanking";

const tabs = {
  leaderboardDetails: "leaderboardDetails",
  top1000Ranking: "top1000Ranking",
} as const;

type TabLabel = (typeof tabs)[keyof typeof tabs];

const tabsList = Object.keys(tabs) as TabLabel[];

const SingleLeaderboard = () => {
  const navigate = useNavigate();
  const { message } = useMessage();
  const { id: leaderboardId } = useParams<{ id: string }>();
  const { useCampaignData } = useCampaigns();
  const { data: leaderboardData } = useCampaignData(leaderboardId || "");

  const [activeTab, setActiveTab] = useState<TabLabel>(tabs.leaderboardDetails);

  const breadcrumbs = {
    parent: {
      label: message({ id: "leaderboards" }),
      path: links.leaderboardsList,
    },
  };

  return (
    <>
      <TopHeader
        title={leaderboardData?.name || ""}
        clearLink={links.leaderboardsList}
        breadcrumbs={breadcrumbs}
      />
      <Subheader>
        <OLTabs
          items={tabsList}
          value={activeTab}
          onChange={(_: React.SyntheticEvent, newValue: TabLabel) => {
            setActiveTab(newValue);
          }}
          data-test-id="tabs"
        />
        <SubheaderActionButton
          onClick={() => navigate(links.editLeaderboard(leaderboardId || ""))}
          text={message({ id: "editLeaderboard" })}
          variant="contained"
        />
      </Subheader>
      {activeTab === tabs.leaderboardDetails && (
        <LeaderboardDetails leaderboardData={leaderboardData} />
      )}
      {activeTab === tabs.top1000Ranking && <TopRanking />}
    </>
  );
};

export default SingleLeaderboard;
